import { selectActiveTutorialConfig, selectTutorialConfig } from "../../../selectors/selectTutorial";
import { IdTutorialStep } from "../IdTutorialStep";
export var checkTutorialConstructConfirm = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var tutorialStepConfig = selectActiveTutorialConfig(state);
    var nextTutorialConfig = selectTutorialConfig(state, tutorialStepConfig.nextStep);
    var hasBuildingId = nextTutorialConfig.buildingId !== undefined;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.confirmConstruction) {
        return undefined;
    }
    if (!hasBuildingId) {
        return undefined;
    }
    if (action.building.typeId !== nextTutorialConfig.buildingId) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialConstructConfirm.ts
// module id = 2461
// module chunks = 3